import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Container, Form, Row, Toast, ToastContainer } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { MakeMessageError } from "../../components/Components";
import { authService } from "../../services/AuthService";
import { aguardar } from "../../utils/utils";
import { BoxArrowRight } from "react-bootstrap-icons";

const initialErrorState = {
    email: [],
    password: [],
    token: []
}

export const ResetPassword: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';
    const [errors, setErrors] = useState(initialErrorState);
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [mensagem, setMensagem] = useState<string>('');
    const [showError, setShowError] = useState<boolean>(false);
    const btnEnviar = useRef<HTMLButtonElement>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (token === "" || email === "") {
            navigate('/login');
        }
    }, [])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        btnEnviar.current?.setAttribute('disabled', 'disabled');

        await authService.resetPassword(token, email, { password, password_confirmation: confirmPassword })
            .then(async (res: any) => {
                await aguardar(3);
                navigate('/login');
                btnEnviar.current?.removeAttribute('disabled');
            })
            .catch((error: any) => {
                btnEnviar.current?.removeAttribute('disabled');
                if (error.status === 400) {
                    setMensagem(error.response.data.message);
                    setShowError(true);
                } else if (error.status === 422) {
                    setErrors(error.response.data);
                } else {
                    setMensagem('Erro no servidor.');
                    setShowError(true);
                }
            })
    }

    return (
        <div className="bg-light" style={{
            alignItems: 'center', 'display': 'flex',
            flexDirection: 'column', 'height': '100vh', justifyContent: 'center'
        }}>
            <Container className="justify-content-center" style={{ maxWidth: '400px', }}>

                <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
                    <Toast bg="danger" onClose={() => setShowError(false)} show={showError} delay={4000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">Error!</strong>
                        </Toast.Header>
                        <Toast.Body className="text-light fw-bold">{mensagem}</Toast.Body>
                    </Toast>

                </ToastContainer>
                <Form onSubmit={handleSubmit}>
                    <Card className="card-primary card-outline">
                        <Card.Header >
                            <h5 className="m-2 text-center">
                                Redefinição de nova senha
                            </h5>

                        </Card.Header>
                        <Card.Body>
                            <Row className=" g-2">
                                <Form.Group className="mb-3" >
                                    <Form.Control
                                        placeholder="Nova senha"
                                        name="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        
                                        type="password"
                                    />
                                    <MakeMessageError errors={errors} field="password" />
                                    <MakeMessageError errors={errors} field="email" />
                                    <MakeMessageError errors={errors} field="token" />
                                </Form.Group>
                            </Row>
                            <Row className="g-2">
                                <Form.Group className="mb-3" >
                                    <Form.Control
                                        placeholder="Confirme a nova senha"
                                        value={confirmPassword}
                                        
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        name="password_confirmation"
                                        type="password"
                                    />
                                    <MakeMessageError errors={errors} field="password_confirmation" />
                                </Form.Group>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <div className="d-flex justify-content-between">
                                <Link to="/login" className="">
                                    <Button variant="secondary" className="ms-2">
                                        <BoxArrowRight size={20} className="" /> Login
                                    </Button>
                                </Link>
                                <Button type="submit" ref={btnEnviar}>
                                    <FontAwesomeIcon icon={faPaperPlane} /> Confirmar
                                </Button>
                            </div>

                        </Card.Footer>
                    </Card>
                </Form>
            </Container>
        </div>
    )
}